"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendC2C = exports.getCampaign = exports.slicePhone = exports.isComercialTime = exports.normalizeErrorInfo = exports.reportJSError = exports.getReCaptchaToken = exports.getClientsIds = exports.webServiceErrorHandler = exports.ERROR_PAGES = exports.HANDLING_CODES = exports.WEB_SERVICES = exports.recaptchaActions = exports.RECAPTCHA_KEY = void 0;
const adabyron_misc_get_scx_campaign_1 = __importDefault(require("@gcloud-npm/adabyron.misc.get-scx-campaign"));
const utils_common_get_cookie_1 = __importDefault(require("@gcloud-npm/utils.common.get-cookie"));
const adabyron_misc_send_retargeting_1 = __importDefault(require("@gcloud-npm/adabyron.misc.send-retargeting"));
const utils_monitoring_front_sonda_1 = __importDefault(require("@gcloud-npm/utils.monitoring.front-sonda"));
exports.RECAPTCHA_KEY = `${process.env.NEXT_PUBLIC_ENV_NAME}` !== "prod"
    ? "6LfX050lAAAAAFcmcOy1KdiEi2k5bBrmqWptug1V"
    : "6LekoJ0lAAAAAHv_IXXvHAPqt43_lzzyXf61h0fV";
exports.recaptchaActions = {
    RETARGETING: "retargeting_collect",
};
exports.WEB_SERVICES = {
    RETARGETING: "retargeting",
};
exports.HANDLING_CODES = {
    NOTHING_TO_DO: 1,
    FATAL: -1,
};
exports.ERROR_PAGES = {
    DEFAULT: "default",
    CHECKOUT: "checkout",
};
exports.webServiceErrorHandler = {
    [exports.WEB_SERVICES.RETARGETING]: {
        service: exports.WEB_SERVICES.RETARGETING,
        handlingCode: {
            default: exports.HANDLING_CODES.NOTHING_TO_DO,
        },
        errorToPrint: exports.ERROR_PAGES.DEFAULT,
    },
};
const getClientsIds = (context) => {
    const { clientIDs } = Object.assign({}, context);
    const { ga: client_id, sessionId: session_id } = Object.assign({}, clientIDs);
    const ga = {};
    if (client_id) {
        ga.client_id = client_id;
    }
    // se incluye session_id solo si existe client_id y tiene formato correcto
    if (session_id && client_id) {
        const gaRegex = /^\d+\.\d+$/;
        if (gaRegex.test(client_id)) {
            ga.session_id = session_id;
        }
    }
    let gaIds = "";
    if (Object.keys(ga).length > 0) {
        gaIds = JSON.stringify(ga);
    }
    return gaIds;
};
exports.getClientsIds = getClientsIds;
const getReCaptchaToken = ({ action = "default" }) => {
    return new Promise((resolve) => {
        if (typeof window === "undefined" || !window.grecaptcha) {
            resolve(null);
        }
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(exports.RECAPTCHA_KEY, { action }).then((token) => {
                resolve(token);
            });
        });
    });
};
exports.getReCaptchaToken = getReCaptchaToken;
const reportJSError = (error, processName, filePath, context) => {
    try {
        if (error instanceof Error) {
            const sonda = new utils_monitoring_front_sonda_1.default({
                processName,
                filePath,
                context,
            });
            sonda.errorMessage({ error });
        }
    }
    catch (e) {
        // Nothing to do
    }
};
exports.reportJSError = reportJSError;
const normalizeErrorInfo = (error, service, contextApi) => {
    const errorInfo = Object.assign({}, exports.webServiceErrorHandler[service]);
    try {
        const { handlingCode } = Object.assign({}, errorInfo);
        const { status: errorCode } = Object.assign({}, error);
        errorInfo.handlingCode = handlingCode[errorCode] || handlingCode.default;
        return errorInfo;
    }
    catch (e) {
        (0, exports.reportJSError)(e, "normalizeErrorInfo", "utils/saga-utils", contextApi);
        return Object.assign(Object.assign({}, errorInfo), { handlingCode: -1 });
    }
};
exports.normalizeErrorInfo = normalizeErrorInfo;
const isComercialTime = () => {
    const ahora = new Date();
    const hora = ahora.getHours();
    return hora >= 9 && hora < 22;
};
exports.isComercialTime = isComercialTime;
const slicePhone = (phone) => {
    const groups = phone === null || phone === void 0 ? void 0 : phone.match(/^(\d{3})(\d{3})(\d{3})$/);
    if (groups) {
        return groups.slice(1).join(" ");
    }
    return null;
};
exports.slicePhone = slicePhone;
const createGetCampaignBody = (context) => {
    var _a, _b, _c;
    try {
        return {
            wbPageId: (_a = context.clientIDs) === null || _a === void 0 ? void 0 : _a.pageId,
            uiGaClientID: (_b = context.clientIDs) === null || _b === void 0 ? void 0 : _b.ga,
            wbSessionId: (_c = context.clientIDs) === null || _c === void 0 ? void 0 : _c.sessId,
            uiMantixCK: (0, utils_common_get_cookie_1.default)("_mc_uuid"),
            // scxFrontVersion: status.version,
            scxFrontHref: context.contextURL,
            scxFrontTimestamp: new Date().toISOString(),
            scxFrontInterest1: null,
            scxFrontInterest2: null,
            scxPageSegment: process.env.NEXT_PUBLIC_ENV_SEGMENT,
            experience: null,
        };
    }
    catch (error) {
        return null;
    }
};
const getCampaign = (context) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const campaignInfo = yield (0, adabyron_misc_get_scx_campaign_1.default)({
            data: createGetCampaignBody(context),
            context,
        });
        return JSON.parse(campaignInfo);
    }
    catch (error) {
        // reportJSError(error, "retargeting", "sagas/c2c-sagas", context);
        return null;
    }
});
exports.getCampaign = getCampaign;
const sendC2C = (context, campaignInfo, data) => __awaiter(void 0, void 0, void 0, function* () {
    const { contextURL } = Object.assign({}, context);
    const dataPayload = {
        campaign: {
            id: "ret-c2c-lead",
            externalId: campaignInfo.tcrmAliasC2C,
        },
        products: [],
        context: {
            url: btoa(contextURL || window.location.href),
            ga: (0, exports.getClientsIds)(context),
        },
        contactInfo: {
            phone: data.phone,
        },
    };
    const recaptchaToken = yield (0, exports.getReCaptchaToken)({
        action: "retargeting_collect",
    });
    return (0, adabyron_misc_send_retargeting_1.default)({ data: Object.assign(Object.assign({}, dataPayload), { recaptchaToken }), context });
});
exports.sendC2C = sendC2C;
//# sourceMappingURL=index.js.map